import { useTranslation } from "react-i18next";
import Price, { PriceModuleProps } from "@ingka/price-module";
import ConditionalRender from "../../components/ConditionalRender";
import { CSSEvent } from "../../types/model";
import { formatEventPrice, isEventFree } from "../../utils/formatPrice";
import { EventPriceAmount, EventPriceNote } from "./style";
import { config } from "../../config";
import styled from "styled-components";

type PropsType = {
  event: CSSEvent;
};

const StyledDiv = styled.div`
  margin-bottom: 10px;
`;


const EventPrice = ({ event }: PropsType) => {
  const { t } = useTranslation();
  const isFree = isEventFree(event.price);
  const amount = (event?.price?.amount || 0);
  let dualCurrencyProps = {}

  if (!isFree && amount) {
    dualCurrencyProps = {
      currentPriceProps: {
        currencyLabel: config.currency,
        integerValue: `${amount || 0}`,
        caption: '',
        priceOfferType: 'regular',
        currencyPosition: 'trailing',
        size: 'large'
      },
      secondaryCurrencyPriceProps: {
        className: 'dualPrice-second-price',
        currencyLabel: config.dualCurrencyInfo.currency,
        integerValue: `${(
          (amount || 0) * config.dualCurrencyInfo?.conversionFactor
        ).toFixed(2)}`,
        caption: '',
        currencyPosition: 'trailing',
        size: 'small'
      },
      productName: '',
    };
  }


  return (
    <>
      <ConditionalRender predicate={!config.dualCurrencyInfo.enable}>
        <EventPriceAmount isFree={isFree}>
          <b>{formatEventPrice(event.price, t)}</b>
        </EventPriceAmount>
        <ConditionalRender predicate={!isFree}>
          <EventPriceNote>{t("event.cost")}</EventPriceNote>
        </ConditionalRender>
      </ConditionalRender>
      <ConditionalRender predicate={config.dualCurrencyInfo.enable && !isFree}>
        <StyledDiv>
          <Price {...dualCurrencyProps as unknown as PriceModuleProps} />
        </StyledDiv>
      </ConditionalRender>
    </>
  );
};

export default EventPrice;
